import { supabase } from "./supabase";
import { dsHttpOrigin } from "../online/net";
import { decodeReplayFile } from "core/src/core/replay-file.js";

// Admin-only: the finished online matches the host has stored (edge-server
// replay/replay-api.js). Files name bots as bots, so none of this is for players.

export interface ReplaySummary {
  matchId: string | null;
  kind: string | null;
  base: string | null;
  mapName: string | null;
  startedAt: number | null;
  endedAt: number | null;
  rounds: number;
  players: number;
  humans: string[];
  deathReports: number;
}
export interface ReplayListItem { key: string; size: number; uploaded: number | null; summary: ReplaySummary }
export interface ReplayList { items: ReplayListItem[]; cursor: string | null; unconfigured?: boolean; error?: string }

export interface DeathReport { round: number; playerId: string; receivedAt: number; serverGameTime: number | null; report: any }
export interface LoadedReplay { meta: any; match: any; deathReports: DeathReport[] }

async function adminToken(): Promise<string | null> {
  try {
    const { data } = supabase ? await supabase.auth.getSession() : { data: { session: null } };
    return data.session?.access_token ?? null;
  } catch {
    return null;
  }
}

export async function fetchReplayList(cursor?: string | null): Promise<ReplayList> {
  const token = await adminToken();
  if (!token) return { items: [], cursor: null, error: "not_signed_in" };
  try {
    const q = cursor ? `?cursor=${encodeURIComponent(cursor)}` : "";
    const res = await fetch(`${dsHttpOrigin()}/api/admin/replays${q}`, { headers: { authorization: `Bearer ${token}` } });
    const body = await res.json();
    return res.ok ? body : { items: [], cursor: null, error: body.error || "failed" };
  } catch {
    return { items: [], cursor: null, error: "network" };
  }
}

export async function fetchReplay(key: string): Promise<LoadedReplay | { error: string }> {
  const token = await adminToken();
  if (!token) return { error: "not_signed_in" };
  try {
    const res = await fetch(`${dsHttpOrigin()}/api/admin/replays/file?key=${encodeURIComponent(key)}`, { headers: { authorization: `Bearer ${token}` } });
    if (!res.ok) return { error: res.status === 404 ? "no_such_replay" : "failed" };
    const decoded = decodeReplayFile(await res.json());
    return decoded || { error: "unknown_format" };
  } catch {
    return { error: "network" };
  }
}
